import React from 'react';
import Fade from 'react-reveal/Fade';
import logo from "../images/logo.svg";
import {
    Link
  } from "react-router-dom";


class Nav extends React.Component {
 
   
    render(){ 
     
        return (
            <Fade top cascade >
                <div className="nav">
                    
                   <div>
                       <Link to="/">
                       <img className="logo" src={logo} alt=""/>
                       </Link>
                      
                   </div>
                   <Link to="/resume" className="resume">
                       <button className="bt">Resume</button>
                    </Link>
                   
                </div>
                </Fade>
            
        );
    } 
}

export default Nav;